import React from "react";
import { Box, Typography } from "@mui/material";
import CustomLabel from "../components/common/CustomLabel";
import { COLORS } from "../assets/theme";

interface SummaryStatsProps {
  summary: {
    count: number;
    delivered: number;
    totalCost?: number;
    totalRate: number;
  };
}

const SummaryStats: React.FC<SummaryStatsProps> = ({ summary }) => {
  const count = summary.count ?? 0;
  const delivered = summary.delivered ?? 0;
  const totalRate = summary.totalRate ?? 0;
  const totalCost = summary.totalCost;

  const calculatedProfit =
  totalCost != null ? totalRate - totalCost : undefined;
  const overallDeliveryPercentage =
    count > 0 ? ((delivered / count) * 100).toFixed(2) + "%" : "0%";

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        flexWrap: "wrap",
        alignItems: "center",
        p: 2,
        mt: 1,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mr: { xs: 0, sm: 2 },
          mb: { xs: 1, sm: 0 },
        }}
      >
        <CustomLabel
          text="Count:"
          fontWeight="600"
          variant="subtitle1"
          color={COLORS.GOLD}
          sx={{ mr: 1 }}
        />
        <Typography variant="subtitle1">{count}</Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mr: { xs: 0, sm: 2 },
          mb: { xs: 1, sm: 0 },
        }}
      >
        <CustomLabel
          text="Delivery:"
          fontWeight="600"
          variant="subtitle1"
          color={COLORS.GOLD}
          sx={{ mr: 1 }}
        />
        <Typography variant="subtitle1">{delivered}</Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mr: { xs: 0, sm: 4 },
          mb: { xs: 1, sm: 0 },
        }}
      >
        <CustomLabel
          text="Delivery %:"
          fontWeight="600"
          variant="subtitle1"
          color={COLORS.GOLD}
          sx={{ mr: 1 }}
        />
        <Typography variant="subtitle1">{overallDeliveryPercentage}</Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mr: { xs: 0, sm: 2 },
          mb: { xs: 1, sm: 0 },
        }}
      >
        <CustomLabel
          text="Total Rate:"
          fontWeight="600"
          variant="subtitle1"
          color={COLORS.GOLD}
          sx={{ mr: 1 }}
        />
        <Typography variant="subtitle1">{totalRate}</Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mr: { xs: 0, sm: 2 },
          mb: { xs: 1, sm: 0 },
        }}
      >
        <CustomLabel
          text="Total Cost:"
          fontWeight="600"
          variant="subtitle1"
          color={COLORS.GOLD}
          sx={{ mr: 1 }}
        />
        <Typography variant="subtitle1">{totalCost ?? "-"}</Typography>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center" }}>
        <CustomLabel
          text="Profit:"
          fontWeight="600"
          variant="subtitle1"
          color={COLORS.GOLD}
          sx={{ mr: 1 }}
        />
        <Typography variant="subtitle1">
          {(calculatedProfit ?? 0).toFixed(3)}
        </Typography>
      </Box>
    </Box>
  );
};

export default SummaryStats;